export default "__VITE_ASSET__mCEHNrqP__"